import React, { useState } from "react";
import Sidebar from "../../components/Admin/Sidebar";
import Header from "../../components/Admin/Header";
import styles from "./UserProfile.module.css";
import { FaUserCircle } from "react-icons/fa";

const UserProfile = () => {
  const [isSuspended, setIsSuspended] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleToggleSuspend = () => {
    setShowModal(true);
  };

  const confirmToggle = () => {
    setIsSuspended(!isSuspended);
    setShowModal(false);
  };

  const cancelToggle = () => {
    setShowModal(false);
  };

  return (
    <div className={styles.container}>
      <Sidebar />
      <div className="content">
        <Header />
        <div className={styles.container}>
          <section className={styles.profileSection}>
            <div className={styles.profileHeader}>
              <div className={styles.userInfo}>
                <FaUserCircle className={styles.userIcon} />
                <div>
                  <h2 className={styles.userName}>
                    Alexa Rawles
                    {isSuspended && (
                      <span className={styles.statusBadge}>Suspended</span>
                    )}
                  </h2>
                  <p className={styles.userDescription}>alexarawles@gmail.com</p>
                </div>
              </div>
              <button
                className={isSuspended ? styles.restoreButton : styles.suspendButton}
                onClick={handleToggleSuspend}
              >
                {isSuspended ? "Restore User" : "Suspend User"}
              </button>
            </div>

            <form className="profile-form">
              <div className="form-grid">
                {[
                  { label: "First Name", type: "text", defaultValue: "Alexa" },
                  { label: "Last Name", type: "text", defaultValue: "Rawles" },
                  {
                    label: "Phone Number",
                    type: "tel",
                    defaultValue: "09012345678",
                  },
                  {
                    label: "Email",
                    type: "email",
                    defaultValue: "alexarawles@gmail.com",
                  },
                  {
                    label: "Password",
                    type: "password",
                    defaultValue: "********",
                  },
                ].map((field, index) => (
                  <div className="form-row" key={index}>
                    <label>{field.label}</label>
                    <input
                      type={field.type}
                      defaultValue={field.defaultValue}
                      disabled
                    />
                  </div>
                ))}
              </div>
            </form>

            {showModal && (
              <div className={styles.modalOverlay}>
                <div className={styles.modal}>
                  <p>
                    Are you sure you want to{" "}
                    {isSuspended ? "restore" : "suspend"} this user?
                  </p>
                  <div className={styles.modalActions}>
                    <button onClick={cancelToggle} className={styles.cancelButton}>
                      Cancel
                    </button>
                    <button onClick={confirmToggle} className={styles.confirmButton}>
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            )}
          </section>

          <section className={styles.reservationsSection}>
            <div>
              <h3 className={styles.sectionTitle}>Booking History</h3>
              <p className={styles.sectionDescription}>List of past and current bookings by this user.</p>
            </div>
            <div className={styles.tableContainer}>
              <table className={styles.table}>
                <thead className={styles.tableHeader}>
                  <tr>
                    <th className={styles.tableHeaderCell}>Room ID</th>
                    <th className={styles.tableHeaderCell}>Room Type</th>
                    <th className={styles.tableHeaderCell}>Stay Dates</th>
                    <th className={styles.tableHeaderCell}>Status</th>
                    <th className={styles.tableHeaderCell}>Total Cost</th>
                    <th className={styles.tableHeaderCell}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className={styles.tableCell}>424</td>
                    <td className={styles.tableCell}>
                      <div className={styles.roomDetails}>
                        <img className={styles.roomImage} src="/images/slide1.jpg" alt="Room" />
                        <span>1 Bedroom Studio...</span>
                      </div>
                    </td>
                    <td className={styles.tableCell}>Jan 15 - Jan 20</td>
                    <td className={`${styles.tableCell} ${styles.statusAwaiting}`}>Awaiting Check-In</td>
                    <td className={styles.tableCell}>₦1,800,000</td>
                    <td className={styles.tableCell}>
                      <a className={styles.bookingLink} href="/ReservationDetails">View Details →</a>
                    </td>
                  </tr>
                  <tr>
                    <td className={styles.tableCell}>512</td>
                    <td className={styles.tableCell}>
                      <div className={styles.roomDetails}>
                        <img className={styles.roomImage} src="/images/slide2.jpg" alt="Room" />
                        <span>2 Bedroom Studio...</span>
                      </div>
                    </td>
                    <td className={styles.tableCell}>Feb 01 - Feb 05</td>
                    <td className={`${styles.tableCell} ${styles.statusCheckedIn}`}>Checked In</td>
                    <td className={styles.tableCell}>₦2,000,000</td>
                    <td className={styles.tableCell}>
                      <a className={styles.bookingLink} href="/ReservationDetails">View Details →</a>
                    </td>
                  </tr>
                  <tr>
                    <td className={styles.tableCell}>233</td>
                    <td className={styles.tableCell}>
                      <div className={styles.roomDetails}>
                        <img className={styles.roomImage} src="/images/slide3.jpg" alt="Room" />
                        <span>1 Bedroom Studio...</span>
                      </div>
                    </td>
                    <td className={styles.tableCell}>Mar 10 - Mar 15</td>
                    <td className={`${styles.tableCell} ${styles.statusCheckedOut}`}>Checked Out</td>
                    <td className={styles.tableCell}>₦1,812,000</td>
                    <td className={styles.tableCell}>
                      <a className={styles.bookingLink} href="/ReservationDetails">View Details →</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className={styles.reviewsSection}>
            <h3 className={styles.sectionTitle}>Review History</h3>
            <div className={styles.reviewCard}>
              <p className={styles.reviewText}>
                "The room was clean, spacious, and the check-in was smooth.
                Loved the location!"
              </p>
              <span className={styles.reviewDate}>Jan 20, 2025</span>
            </div>
            <div className={styles.reviewCard}>
              <p className={styles.reviewText}>
                "Everything was great except the Wi-Fi was a bit slow during the
                night."
              </p>
              <span className={styles.reviewDate}>Feb 6, 2025</span>
            </div>
            <div className={styles.reviewCard}>
              <p className={styles.reviewText}>
                "Amazing service. Would definitely stay again!"
              </p>
              <span className={styles.reviewDate}>Mar 16, 2025</span>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
